export * from './reasonType'

export * from './reasonCase'

export * from './applyFail'

export * from './paymentMethod'

export * from './purchaseConfirmation'

export * from './calendar'

/**
 * APIGW의 에러에 사용되는 이름
 * @deprecated
 **/
export const GwErrorName = 'GW_ERROR_NAME' as const

/** 대기열 추방 사유 */
export const WaitingExpelledReason = {
    /** 재고부족 */
    SOLD_OUT: 'SOLD_OUT',
    /** 판매하지 않는 상품 */
    NOT_ON_SALE: 'NOT_ON_SALE',
} as const

export type WaitingExpelledReasonType = Constant<typeof WaitingExpelledReason>

/** 선물받는 사람 선택으로 보내야하는 코드 목록 */
export const GiftSendCodes: string[] = [
    'GIFTING_FRIENDS_SESSION_KEY_EMPTY',
    'GET_GIFTING_PLAYER_IDS_FAILED',
    // @ref https://oss.fin.navercorp.com/payOrder/order-sheet/issues/10385
    'GIFTING_PLAYER_KEY_NOT_FOUND',
    'GIFTING_PLAYER_KEY_EMPTY',
    // @ref https://oss.fin.navercorp.com/payOrder/order-sheet/issues/10722
    'GIFTING_PLAYER_KEY_NOT_REGISTERED',
]

/** 에러 타입 */
export const ErrorType = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    EXCEPTION_HANDLING: 'EXCEPTION_HANDLING',
    ETIMEDOUT_FAILED: 'ETIMEDOUT_FAILED',
    AUTHORIZATION_FAILED: 'AUTHORIZATION_FAILED',
    API_GW_ERROR: 'API_GW_EXCEPTION',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const

export const ValidationFailureCodes = [
    ErrorType.VALIDATION_FAILED,
    ErrorType.ORDER_ALREADY_CREATED,
    ErrorType.ETIMEDOUT_FAILED,
]

export const ErrorMessage = {
    OUT_OF_STOCK: '품절, 판매중지 또는 구매 불가한 상품이 있습니다. 이전 페이지로 이동합니다.',
} as const
